import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { PickupAddressSchema } from "./create-ups-pickup";

export const requestRecurringPickup = {
  name: "requestRecurringPickup" as const,
  input: z.object({
    teamId: zExt.objectId(),
    upsGhostLocationId: z.string(),
    pickupAddress: PickupAddressSchema,
    pickupLocation: z.string(),
    readyTime: z.string(),
    closeTime: z.string(),
    packageCount: z.number().int().positive(),
    specialInstructions: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
